<div class="flex flex-col">
  <app-page-loader *ngIf="dataLoading"></app-page-loader>
  <div dir="rtl" class="mb-16">
    <mat-icon svgIcon="close" class="close-icon cursor-pointer" (click)="matDialogRef.close(deferred)"></mat-icon>
  </div>
  <ng-container *ngIf="!deferred && !hasError; else updateSuccessful">
    <div class="flex flex-col items-center deferral-reason">
      <div class="mat-headline-5 mb-16">{{'AUTO_UPDATE.DIALOG.SKIP_UPDATE' | transloco}}</div>
      <div>{{'AUTO_UPDATE.DIALOG.UPDATE_WILL_BE_SKIPPED' | transloco}}</div>
      <div class="mb-32">
        {{ data.deferralCount === 1 ?
          ('AUTO_UPDATE.DIALOG.YOU_CAN_SKIP_UPDATE_ONCE' | transloco) :
          ('AUTO_UPDATE.DIALOG.YOU_CAN_SKIP_UPDATE_TIMES' | transloco: {deferralCount: data.deferralCount}) }}
      </div>
      <div class="flex flex-col">
        <div class="flex flex-row items-center mb-8">
          <div class="reason-label mr-8">{{'AUTO_UPDATE.DIALOG.REASON_FOR_THE_SKIP' | transloco | uppercase}}</div>
          <div class="reason-label mr-12">({{'AUTO_UPDATE.DIALOG.OBLIGATORY' | transloco}})</div>
          <mat-icon svgIcon="info" class="icon-sm info-icon"></mat-icon>
        </div>
        <textarea placeholder="{{'AUTO_UPDATE.DIALOG.TYPE' | transloco}}"
                  [formControl]="deferralReasonControl"></textarea>
        <app-error [control]="deferralReasonControl"></app-error>
      </div>
    </div>
    <span class="flex-auto"></span>
    <div class="flex flex-row items-center mb-32">
      <button class="white mr-20" (click)="matDialogRef.close()">{{'BUTTONS.CANCEL' | transloco}}</button>
      <button class="accent"
              [disabled]="deferralReasonControl.invalid"
              (click)="deferUpdate()">{{'AUTO_UPDATE.DIALOG.SKIP_UPDATE' | transloco}}</button>
    </div>
  </ng-container>
  <ng-template #updateSuccessful>
    <div @updateSuccessful class="flex flex-col flex-auto updated-successfully pl-90 pr-90">
      <ng-container *ngIf="deferred; else showHasError">
        <div class="flex flex-row items-center mb-44">
          <mat-icon svgIcon="done" class="mr-20"></mat-icon>
          <div class="mat-headline-5">{{'AUTO_UPDATE.DIALOG.SKIPPED_SUCCESSFULLY' | transloco}}</div>
        </div>
      </ng-container>
      <ng-template #showHasError>
        <div class="flex flex-row items-center mb-44">
          <mat-icon svgIcon="info" class="mr-20"></mat-icon>
          <div class="mat-headline-5 mb-0">{{'AUTO_UPDATE.DIALOG.SKIP_FAILED' | transloco}}</div>
        </div>
      </ng-template>
      <div class="mat-subtitle-2 mr-12 mb-8">{{'AUTO_UPDATE.DIALOG.REASON_FOR_THE_SKIP' | transloco}}</div>
      <div class="mr-12 mb-32">{{deferralReasonControl.value}}</div>
      <span class="flex-auto"></span>
      <button (click)="matDialogRef.close(deferred)" class="flex items-center accent mb-32 w-80">{{'BUTTONS.CLOSE' | transloco}}</button>
    </div>
  </ng-template>
</div>
